import { render, staticRenderFns } from "./lookattachmentDialog.vue?vue&type=template&id=72976692&scoped=true"
import script from "./lookattachmentDialog.vue?vue&type=script&lang=js"
export * from "./lookattachmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72976692",
  null
  
)

export default component.exports